export const getPadding = (size, axis) => {
  // Mapping based on UI_SCALES:
  // none=0px, xxs=4px, xs=8px, sm=12px, md=16px, lg=24px, xl=32px, 2xl=48px, 3xl=64px

  const map = {
    none: axis === 'x' ? 'px-0' : 'py-0',
    xxs:  axis === 'x' ? 'px-1' : 'py-1',  // 4px
    xs:   axis === 'x' ? 'px-2' : 'py-2',  // 8px
    sm:   axis === 'x' ? 'px-3' : 'py-3',  // 12px
    md:   axis === 'x' ? 'px-4' : 'py-4',  // 16px
    lg:   axis === 'x' ? 'px-6' : 'py-6',  // 24px
    xl:   axis === 'x' ? 'px-8' : 'py-8',  // 32px
    '2xl': axis === 'x' ? 'px-12' : 'py-12', // 48px
    '3xl': axis === 'x' ? 'px-16' : 'py-16'  // 64px
  };

  return map[size] || map.md;
};
export const getInputPadding = (size) => {
  // Mapping based on UI_SCALES.padding:
  // none=0px, xxs=4px, xs=8px, sm=12px, md=16px, lg=24px, xl=32px, 2xl=48px, 3xl=64px
  
  const map = {
    none:  'px-0',
    xxs:   'px-1',   // 4px
    xs:    'px-2',   // 8px
    sm:    'px-3',   // 12px
    md:    'px-4',   // 16px (Standard)
    lg:    'px-6',   // 24px
    xl:    'px-8',   // 32px
    '2xl': 'px-12',  // 48px
    '3xl': 'px-16'   // 64px
  };

  return map[size] || map.md;
};

export const getGap = (size) => {
  // Mapping based on UI_SCALES.spacing:
  // none=0px, xxs=2px, xs=4px, sm=8px, md=16px, lg=24px, xl=32px, 2xl=48px, 3xl=64px
  
  const map = {
    none:  'gap-0',
    xxs:   'gap-0.5', // 2px
    xs:    'gap-1',   // 4px
    sm:    'gap-2',   // 8px
    md:    'gap-4',   // 16px
    lg:    'gap-6',   // 24px
    xl:    'gap-8',   // 32px
    '2xl': 'gap-12',  // 48px
    '3xl': 'gap-16'   // 64px
  };

  return map[size] || map.md;
};

export const getFontSize = (size) => {
  // Mapping based on UI_SCALES.fontSize:
  // xxs=11px, xs=12px, sm=14px, md=16px, lg=18px, xl=20px, 2xl=24px, 3xl=30px, 4xl=36px

  const map = {
    xxs:   'text-[11px]', // Custom small size
    xs:    'text-xs',     // 12px
    sm:    'text-sm',     // 14px
    md:    'text-base',   // 16px (Standard)
    lg:    'text-lg',     // 18px
    xl:    'text-xl',     // 20px
    '2xl': 'text-2xl',    // 24px
    '3xl': 'text-3xl',    // 30px
    '4xl': 'text-4xl'     // 36px
  };

  return map[size] || map.md;
};

export const getRadius = (size) => {
  // Mapping based on UI_SCALES.radius:
  // none=0px, xs=2px, sm=4px, md=8px, lg=12px, xl=16px, 2xl=24px, full=9999px

  const map = {
    none:  'rounded-none',
    xs:    'rounded-sm',   // 2px
    sm:    'rounded',      // 4px
    md:    'rounded-lg',   // 8px (Note: Tailwind 'lg' matches your 8px definition)
    lg:    'rounded-xl',   // 12px
    xl:    'rounded-2xl',  // 16px
    '2xl': 'rounded-3xl',  // 24px
    full:  'rounded-full'
  };

  return map[size] || map.md;
};

export const getHeight = (size) => {
  // Mapping suitable for Inputs, Buttons, and Spacers
  
  const map = {
    xxs:   'h-6',    // 24px
    xs:    'h-7',    // 28px
    sm:    'h-8',    // 32px
    md:    'h-10',   // 40px (Standard)
    lg:    'h-12',   // 48px
    xl:    'h-14',   // 56px
    '2xl': 'h-16',   // 64px
    '3xl': 'h-20'    // 80px
  };

  return map[size] || map.md;
};

export const getShadow = (size) => {
  // Mapping to standard Tailwind shadow classes
  const map = {
    none:  'shadow-none',
    xs:    'shadow-sm',      // Subtle
    sm:    'shadow',         // Base shadow
    md:    'shadow-md',      // Standard depth
    lg:    'shadow-lg',      // High depth
    xl:    'shadow-xl',      // Very high depth
    '2xl': 'shadow-2xl'      // Deepest
  };

  return map[size] || 'shadow-none';
};

export const getFontFamily = (fontName) => fontName || "Inter";

export const getFlexAlignment = (align) => {
  const map = { left: 'justify-start', center: 'justify-center', right: 'justify-end' };
  return map[align] || 'justify-start';
};

export const getAlignment = (align) => {
  const map = { left: "text-left", center: "text-center", right: "text-right" };
  return map[align] || "text-left";
};
